import Banner from "../../sections/common/banner";
// import SectionClients2 from "../../sections/home/index2/section-clients2";
import ItodoImage from "../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { bannerData } from "../../../globals/banner";
import { blogData } from "../../../globals/blogData";
import "../../../pagination-styles.css";

function BlogGridPage() {
    // Convert blogData object to array for easier mapping
    const blogPosts = Object.values(blogData);

    return (
        <>
            <Banner _data={bannerData.bloggrid} />

            {/* SECTION CONTENT START */}
            <div className="section-full p-t100 p-b0 bg-white mobile-page-padding">
                {/* GALLERY CONTENT START */}
                <div className="container">
                    <div className="masonry-outer mfp-gallery news-grid clearfix row">
                        {blogPosts.map((post) => (
                            <div key={post.id} className="masonry-item col-lg-4 col-md-6 col-sm-12 m-b30">
                                <div className="sx-latest-post-st-1">
                                    <div className="sx-post-media sx-img-effect img-reflection">
                                        <NavLink to={`/blogs/detail/${post.id}`}>
                                            <ItodoImage src={post.image} alt={post.title} />
                                        </NavLink>
                                    </div>
                                    <div className="sx-post-info p-t30">
                                        <div className="sx-post-meta">
                                            <ul>
                                                <li className="post-date">
                                                    <NavLink to={`/blogs/detail/${post.id}`}>
                                                        <i className="fa fa-calendar" />
                                                        {post.date || "01 Jan 2023"}
                                                    </NavLink>
                                                </li>
                                                <li className="post-author">
                                                    <NavLink to={`/blogs/detail/${post.id}`}>
                                                        <i className="fa fa-comments" />
                                                        {post.comments || "0"} Comments
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="sx-post-title">
                                            <h4 className="post-title">
                                                <NavLink to={`/blogs/detail/${post.id}`}>
                                                    {post.title}
                                                </NavLink>
                                            </h4>
                                        </div>
                                        <div className="sx-post-readmore">
                                            <NavLink 
                                                to={`/blogs/detail/${post.id}`} 
                                                title="READ MORE" 
                                                rel="bookmark" 
                                                className="site-button icon"
                                            >
                                                <i className="fa fa-long-arrow-right" />
                                                Read More
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    {/* Only show pagination if there are more than 3 posts */}
                    {blogPosts.length > 3 && (
                        <div className="sx-pagination-wra text-center">
                            <ul className="sx-pagination">
                                <li><button type="button" className="pagination-btn"><span className="fa fa-long-arrow-left" /></button></li>
                                <li><button type="button" className="pagination-btn">01</button></li>
                                <li className="active"><button type="button" className="pagination-btn">02</button></li>
                                <li><button type="button" className="pagination-btn">03</button></li>
                                <li><button type="button" className="pagination-btn">04</button></li>
                                <li><button type="button" className="pagination-btn"><span className="fa fa-long-arrow-right" /></button></li>
                            </ul>
                        </div>
                    )}
                </div>
                {/* GALLERY CONTENT END */}
            </div>
            {/* SECTION CONTENT END  */}
        </>
    )
}

export default BlogGridPage;